<template>
  <div
    class="defaultBranded pageBody"
    style="margin: 0 0 60px;"
  >
    <div class="flex-column align-items-center padding0 gap16 stretch">
      <h2>Hiba - {{ error.statusCode }}</h2>
      <div class="whitebox errorBox flex-column align-items-center padding16 gap12">
        <p
          v-if="error.statusCode === 404"
          class="p-caption bold text-center"
        >
          A kért oldal nem található. Elképzelhető, hogy elírtál valamit a címben.
        </p>
        <p
          v-if="error.statusCode === 500"
          class="p-caption bold text-center"
        >
          Belső szerver hiba - a hiba nálunk van. Kérjük frissítsd az oldalt, ha a hiba nem hárul el, próbáld újra később!
        </p>
        <p class="p-caption text-center">
          {{ error.statusMessage }}
        </p>
        <IllustrationsErrorMachine class="defaultBranded" />
      </div>
    </div>
    <AppFooter />
  </div>
</template>

<script setup>
const props = defineProps({
  error: Object,
})

onBeforeMount(() =>
{
  if(props.error.toString().includes("error loading dynamically imported module")){
      window.location.reload();
  }
})
</script>


<style>
.defaultBranded {
  --brandPrimary: #009860;
  --brandPrimaryLight: #dd9860;
  --brandPrimaryDark: #005830;
  --brandSecondary: #E20615;;
  --black: #121212;
  --gray600: #505050;
  --gray400: #ababab;
  --gray200: #e2e2e2;
  --gray50: #f7f7f7;
  --systemError: #EC3F21;;
  --systemWarning: #F7B802;;
  --systemSuccess:  #008E5A;;
  --systemSuccessLight: #E5F5ED;;
  --systemErrorLight: #FBE9E8;
}
</style>

<style scoped>
.errorBox {
  width: 95%;
  max-width: 612px;
}

.pageBody {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  font-family: Roboto;
  color: #121212;
  background-color: #efefef;
  align-self: stretch;
  flex-grow: 1;
}
</style>